import React from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';

const MobileSidebarToggle = ({ onOpen, trialBannerHeight = 0 }) => (
  <div
    className="lg:hidden fixed left-0 right-0 z-40 flex h-12 items-center px-4 bg-neutral-100/90 backdrop-blur-sm border-b border-gray-200"
    style={{ top: `${trialBannerHeight}px` }}
  >
    <button
      type="button"
      className="-m-2.5 p-2.5 text-gray-700"
      onClick={onOpen}
      aria-label="Open navigation"
    >
      <Bars3Icon className="h-6 w-6" aria-hidden="true" />
    </button>
  </div>
);

export default MobileSidebarToggle;
